<template>
  <v-stepper
    v-model="passoAtual"
    class="mt-2"
    style="box-shadow: none;"
  >
    <v-stepper-header
      class="grey lighten-3"
      style="box-shadow: none;"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-step
          :key="'step_' + index"
          :step="item.step"
          :complete="passoAtual > item.step"
          complete-icon="check"
          :data-cy="'passo_marcador_' + item.step"
        />

        <v-divider
          v-if="quantDePassos.length > item.step"
          :key="'divider_' + index"
        />
      </template>
    </v-stepper-header>

    <v-stepper-items
      class="grey lighten-3"
    >
      <template v-for="(item, index) in quantDePassos">
        <v-stepper-content
          :key="'content_' + index"
          :step="item.step"
          :class="$vuetify.breakpoint.smAndDown ? 'height-content' : ''"
          class="pa-0"
        >
          <PassoDadosCartao
            v-if="item.step === 1"
            @formValidado="ativarPasso($event,index)"
          />
          <PassoCodigoConfirmacao
            v-if="item.step === 2"
            @formValidado="ativarPasso($event,index)"
          />
          <PassoIdentifiqueCartao
            v-if="item.step === 3"
            @formValidado="ativarPasso($event,index)"
          />

          <div
            :class="$vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile botoes-rodape--stepper'"
            class="botoes-rodape pa-3 pa-md-0 px-md-0"
          >
            <BtnVoltar
              :key="'voltar_' + index"
              :index="item.step"
              @irParaAnterior="novoValor => passoAtual = novoValor"
            />

            <BtnProsseguir
              v-if="item.step < 3"
              :key="'prosseguir_' + index"
              :index="item.step"
              :desabilitar-btn="item.possuiValidacao"
              :nao-proseguir="item.msgConfirmacao"
              @irParaProximo="novoValor => passoAtual = novoValor"
            />

            <BtnSalvar
              v-else
              :desabilitar-btn="item.possuiValidacao"
              :dados-cartao="dadosCartao"
              @respostaApi="respostaApi"
            />
          </div>
          <SnackBar
            :mensage="snackBar.message"
            :snackbar="snackBar.show"
            :button="true"
            :color="snackBar.color"
            :timeout="snackBar.timeout"
            @changeSnackBar="redirecionaLista"
          />
        </v-stepper-content>
      </template>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import PassoDadosCartao from '@/components/MeuPerfil/CartoesCredito/PassoDadosCartao.vue';
import PassoCodigoConfirmacao from '@/components/MeuPerfil/CartoesCredito/PassoCodigoConfirmacao.vue';
import PassoIdentifiqueCartao from '@/components/MeuPerfil/CartoesCredito/PassoIdentifiqueCartao.vue';
import BtnProsseguir from '@/components/Steppers/BtnProsseguir.vue';
import BtnVoltar from '@/components/Steppers/BtnVoltar.vue';
import BtnSalvar from '@/components/MeuPerfil/CartoesCredito/BtnSalvar.vue';
import SnackBar from '@/components/SnackBar.vue';

const { mapActions, mapState } = createNamespacedHelpers('meuperfil');

export default {
  name: 'CartoesStepper',

  components: {
    PassoDadosCartao,
    PassoCodigoConfirmacao,
    PassoIdentifiqueCartao,
    BtnProsseguir,
    BtnSalvar,
    BtnVoltar,
    SnackBar,
  },

  data() {
    return {
      passoAtual: 1,
      btAtualDisabled: true,
      dadosCartao: {},
      quantDePassos: [
        {
          step: 1, form: {}, possuiValidacao: true, msgConfirmacao: false,
        },
        {
          step: 2, form: {}, possuiValidacao: true, msgConfirmacao: false,
        },
        {
          step: 3, form: {}, possuiValidacao: true, msgConfirmacao: false,
        },
      ],
      snackBar: {
        message: '',
        color: 'success',
        timeout: 5000,
        show: false,
      },
    };
  },

  computed: {
    ...mapState(['assinaturaCadastrarCartao', 'recobrarAposCadastro']),
  },

  watch: {
    passoAtual() {
      this.montarObjeto();
    },
  },

  methods: {
    ...mapActions([
      'setAssinaturaCadastrarCartao',
      'setRecobrarAposCadastro',
      'setAssinaturaRecobrar',
    ]),

    ativarPasso(dadosForm, indexArray) {
      this.quantDePassos[indexArray].possuiValidacao = !dadosForm.validado;
      this.quantDePassos[indexArray].form = dadosForm.form;
      if (indexArray === 2 && dadosForm.validado) {
        this.montarObjeto();
      }
    },

    montarObjeto() {
      if (this.passoAtual === 3) {
        const passoUm = this.quantDePassos[0].form;
        const passoDois = this.quantDePassos[1].form;
        const passoTres = this.quantDePassos[2].form;
        Object.assign(this.dadosCartao, passoUm, passoDois, passoTres);
      }
    },

    respostaApi(success, error = null) {
      this.snackBar.message = success ? 'Cartão adicionado' : error;
      this.snackBar.color = success ? 'success' : 'error';
      this.snackBar.show = true;
    },

    redirecionaLista(value) {
      this.snackBar.show = value.visible;
      const salvouComSucesso = this.snackBar.color === 'success';

      if (this.recobrarAposCadastro && salvouComSucesso) {
        // Cadastro confirmado: só agora ARMA a recobrança e vai à lista,
        // onde o Card (consumidor da flag) a dispara. Evita cobrar cartão antigo no abandono (M1)
        // e garante a entrega mesmo iniciando pela troca de forma (A1).
        this.setAssinaturaRecobrar(this.recobrarAposCadastro);
        this.setRecobrarAposCadastro(null);
        this.setAssinaturaCadastrarCartao(false);
        this.$router.push('/minhas-compras');
        return;
      }

      if (this.assinaturaCadastrarCartao) {
        this.setAssinaturaCadastrarCartao(false);
        this.$router.go(-1);
      } else {
        this.$router.push('/meu-perfil/cartoes-credito');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
